export default __webpack_public_path__ + "static/media/block.33df5d40.svg";